import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdPhone } from "react-icons/md";
import { useTheme } from "../../common/hooks/useTheme";
import { selectIsOnline } from "../../store/slices/networkSlice";
import { selectStoreItem } from "../../store/slices/storeListSlice";
import StoreSchedule from "../../common/components/storeSchedule/StoreSchedule";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import { Banner } from "../main/components/banner/Banner";
import styles from "./ContactsItemScreen.module.scss";
import { Share } from "../../common/components/share/Share";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";
import { GoalType } from "../../common/types/enums";
import useMetrics from "../../common/hooks/useMetrics";

export default function ContactsItemScreen() {
  const { id } = useParams<{ id: string }>();
  const { theme } = useTheme();
  const isOnline = useSelector(selectIsOnline);
  const item = useSelector(selectStoreItem(Number(id)));
  const { trackGoal } = useMetrics();

  const handlePhonePress = (phone?: string) => {
    if (phone) {
      trackGoal(GoalType.CALL_CLICK, phone);
      window.location.href = `tel:${phone}`;
    }
  };

  if (!item) {
    return (
      <div
        className={styles.container}
        style={{ backgroundColor: theme.background }}
      >
        <PageMeta customTitle="Торговая точка не найдена" />
        <ProductHeader
          title="Торговая точка не найдена"
          isFavorite={false}
          showFavorite={false}
          textColor={theme.text}
          borderColor={theme.border}
          // backgroundColor={theme.background}
        />
      </div>
    );
  }

  const location = {
    lat: item.address.latitude || 0,
    lng: item.address.longitude || 0,
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta
        itemName={item.name}
        itemDescription={item.description}
        itemImageFile={item.files?.[0]}
        itemId={item.id}
        type="website"
      />
      <ProductHeader
        title={item.name}
        isFavorite={false}
        showFavorite={false}
        textColor={theme.text}
        borderColor={theme.border}
        // backgroundColor={theme.background}
        rightContent={<Share item={item} />}
      />

      <div className={styles.bannerWrapper}>
        <Banner items={[item]} variantProp={"base"} />
      </div>

      <div className={styles.scrollView}>
        <div className={styles.content}>
          <div className={styles.contactsAndSchedule}>
            <div className={styles.contactsColumn}>
              <div className={styles.addressBlock}>
                <h3
                  className={styles.descriptionTitle}
                  style={{ color: theme.text }}
                >
                  Адрес
                </h3>
                <p
                  className={styles.address}
                  style={{ color: theme.textSecondary }}
                >
                  {item.address.value}
                </p>
                <p
                  className={styles.address}
                  style={{ color: theme.textSecondary }}
                >
                  {item.city.value}
                </p>
              </div>

              {item.phone_number && (
                <div className={styles.phoneBlock}>
                  <h3
                    className={styles.descriptionTitle}
                    style={{ color: theme.text }}
                  >
                    Телефон
                  </h3>
                  <button
                    className={styles.phoneButton}
                    onClick={() => handlePhonePress(item.phone_number)}
                  >
                    <MdPhone size={16} color={theme.primary} />
                    <span
                      className={styles.phone}
                      style={{ color: theme.primary }}
                    >
                      {item.phone_number}
                    </span>
                  </button>
                </div>
              )}
            </div>

            {/* Расписание магазина */}
            {item.schedule && item.schedule.length > 0 && (
              <div className={styles.scheduleWrapper}>
                <h3
                  className={styles.descriptionTitle}
                  style={{ color: theme.text }}
                >
                  Режим работы
                </h3>
                <StoreSchedule schedule={item.schedule} />
              </div>
            )}
          </div>

          {item.temporarilyDisabled && (
            <p className={styles.notWorks} style={{ color: theme.danger }}>
              Временно не работает
            </p>
          )}
        </div>
      </div>

      {/* {isOnline && (
        <div className={styles.mapWrapper}>
          <GMapForMarker location={location} name={item.name} />
        </div>
      )} */}
      {isOnline && (
        <div className={styles.mapWrapper}>
          <iframe
            className={styles.map}
            src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=${location.lat},${location.lng}`}
            loading="lazy"
            allowFullScreen
            title={item.name}
          />
        </div>
      )}
    </div>
  );
}
